import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../../../common/api/http.service';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {APIResponse, Filter} from '@core/interfaces/system/system-common';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {HydrogenGasTrendingDashboardData, HydrogenUnits} from '@core/interfaces/live/hydrogen-tending';
import {LatestModelStatus} from '@core/interfaces/live/live';

@Injectable()
export class HydrogenTrendingApi {
    private readonly PREFIX = 'live/output/hydrogen-trending';

    constructor(private api: HttpService) {}

    public getHydrogenGasTrendingUnits(): Observable<HydrogenUnits> {
        return this.api.get(`${this.PREFIX}/units`);
    }

    public getHydrogenGasTrendingDatasource(id: string, filters: Filter[]): Observable<DataSource> {
        return this.api.postServerDataSource(`${this.PREFIX}/list?filterByassetId=${id}`, filters);
    }

    public getCountResults(assetId: string, uploadTime?: string): Observable<number> {
        return this.api
            .get(`${this.PREFIX}/count`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<number>) => res.response));
    }

    public getHydrogenGasTrendingLatestModelStatus(
        assetId: string,
        uploadTime?: string,
    ): Observable<LatestModelStatus> {
        return this.api
            .get(`${this.PREFIX}/latest`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<LatestModelStatus>) => res.response));
    }

    public getHydrogenGasTrendingDashboardData(
        chart: string,
        assetId: string,
        uploadTime?: string,
    ): Observable<HydrogenGasTrendingDashboardData> {
        return this.api
            .get(`${this.PREFIX}/data/${chart}`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<HydrogenGasTrendingDashboardData>) => res.response));
    }
}
